import React from 'react';
import PropTypes from 'prop-types';

function TotalCounter(props) {
  const { total, counterLabel } = props;
  const pullRight = total <= 0 ? { marginLeft: 'auto' } : null;
  return (
    <div className="content-info-cell -counter" style={pullRight}>
      <div className="content-counter">
        {counterLabel ? `Всего ${counterLabel}: ` : 'Всего: '}
        <span className="content-counter-num">{total}</span>
      </div>
    </div>
  );
}

TotalCounter.propTypes = {
  total: PropTypes.number.isRequired,
  counterLabel: PropTypes.string,
};

export default TotalCounter;
